
//import Artwork from 'parts/Artwork';
import StreamSection from './StreamSection';
import TextSection from 'parts/TextSection';
import _ from 'lodash';

const renderProviderStreaming = (baseUrl, data) => {
  if (data) {
    //Streaming information of this film is made available through JustWatch.
    return (
      <>
        <div style={{marginTop:'30px'}}></div>
        <StreamSection
          className='streaming-section-bottom-margin'
          type="Streaming Services"
          text=""
          data={data}
          baseUrl={baseUrl} />
      </>
    );
  }
};

const renderProviderBuy = (baseUrl, buy, rent) => {
  if (buy || rent) {
    var origArr = [];
    var updatingArr = [];
    if (buy) {
      origArr = buy;
      updatingArr = rent;
    } else {
      origArr = rent;
      updatingArr = buy;
    }
    var data = _.unionBy(updatingArr, origArr, 'provider_id');
    //Purchase information of this film is made available through JustWatch.
    return (
      <>
        <div style={{marginTop:'30px'}}></div>
        <StreamSection
          className='streaming-section-bottom-margin'
          type="Buy or Rent"
          text=""
          data={data}
          baseUrl={baseUrl} />
      </>
    );
  }
};

const renderProviders = (baseUrl, streaming) => {
  var data = null;
  if (Object.keys(streaming)[0]) {
    var key = Object.keys(streaming)[0];
    data = streaming[key];
  }
  if (streaming.US) {
    data = streaming.US;
  }
  if (data) {
    return (
      <>
        {renderProviderStreaming(baseUrl, data.flatrate)}
        {renderProviderBuy(baseUrl, data.buy, data.rent)}
      </>
    );
  } else {
    return (
      <>
        <div style={{marginTop:'30px'}}></div>
        <TextSection
          className='streaming-section-bottom-margin'
          heading="Streaming and Purchase"
          text="Streaming and purchase of this film is not available." />
      </>
    );
  }
};


const StreamingProviders = ({
  baseUrl,
  streaming
}) => (
  <>
    {renderProviders(baseUrl, streaming)}
  </>
);

export default StreamingProviders;
